// extracted by mini-css-extract-plugin
export default {"tooltip_container":"Tooltip_tooltip_container__0pR2W"};